module.exports = __webpack_public_path__ + "static/media/Elf5.0696e2ac.png";